/* unplugin-vue-components disabled */import script from "./UserLookup.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLookup.vue?vue&type=script&lang=ts&setup=true"

import "./UserLookup.vue?vue&type=style&index=0&id=88cf8ffc&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88cf8ffc"]])

export default __exports__